import React from 'react'
import PropTypes from 'prop-types'

import AddToCartButton from './AddToCartButton'
import RemoveOfferButton from './RemoveOfferButton'
import PriceOfferDecisionButtons from './PriceOffer/PriceOfferDecisionButtons'
import PriceOfferNegotiateSection from './PriceOffer/PriceOfferNegotiateSection'

const BottomHeaderRowPriceOffer = (props) => {
  const ButtonsElement = (() => {
    switch (props.typeData.status) {
      case 'accepted':
        if (props.typeData.isOwner) {
          return (
            <AddToCartButton offerId={props.typeData.id} itemId={props.typeData.itemId} price={props.typeData.price} />
          )
        }
        return null

      case 'declined':
        return null
      case 'withdrawn':
        return null
      case 'in_progress':
        if (props.typeData.isOwner) {
          return <RemoveOfferButton offerId={props.typeData.id} onRemoveOfferSuccess={props.onRemoveOfferSuccess} />
        }
        return (
          <div className="conversation__offer-actions">
            <PriceOfferNegotiateSection
              offerId={props.typeData.id}
              conversationId={props.conversationId}
              onPriceOfferSubmitSuccess={props.onPriceOfferSubmitSuccess}
            />
            <PriceOfferDecisionButtons
              offerId={props.typeData.id}
              conversationId={props.conversationId}
              onPriceOfferDecisionSuccess={props.onPriceOfferDecisionSuccess}
            />
          </div>
        )

      case 'buyer_offer':
        if (props.typeData.isOwner) {
          return null
        }
        return (
          <div className="conversation__offer-actions">
            <PriceOfferNegotiateSection
              offerId={props.typeData.id}
              conversationId={props.conversationId}
              onPriceOfferSubmitSuccess={props.onPriceOfferSubmitSuccess}
            />
            <PriceOfferDecisionButtons
              offerId={props.typeData.id}
              conversationId={props.conversationId}
              onPriceOfferDecisionSuccess={props.onPriceOfferDecisionSuccess}
            />
          </div>
        )

      case 'seller_offer':
        if (props.typeData.isOwner) {
          return (
            <div className="conversation__offer-actions">
              <PriceOfferNegotiateSection
                offerId={props.typeData.id}
                conversationId={props.conversationId}
                onPriceOfferSubmitSuccess={props.onPriceOfferSubmitSuccess}
              />
              <AddToCartButton
                offerId={props.typeData.id}
                itemId={props.typeData.itemId}
                price={props.typeData.price}
              />
            </div>
          )
        }
        return null
    }
  })()

  return (
    <div className="header__row is-with-border">
      <div className="header__about-conversation u-float-left">
        <div className="conversation-info u-mr10">
          Status:
          <span className="conversation-status u-ml10">
            {
              props.typeData.isOwner ? (
                <b>{I18n.t(`price_offers.status_for_buyer.${props.typeData.status}`)}</b>
              ) : (
                <b>{I18n.t(`price_offers.status_for_seller.${props.typeData.status}`)}</b>
              )
            }
          </span>
        </div>
        <div className="conversation-info u-ml10">
          Original price:
          <span className="conversation-price-offer u-ml10 u-mr10">
            <b>
              {numeral(props.typeData.itemOriginalPrice).format('$0.00')}
            </b>
          </span>
          Price offer:
          <span className="conversation-price-offer u-ml10">
            <b>
              {numeral(props.typeData.price).format('$0.00')}
            </b>
          </span>
        </div>
      </div>
      <div className="header__conversation-actions u-float-right">
        {ButtonsElement}
      </div>
    </div>
  )
}

BottomHeaderRowPriceOffer.propTypes = {
  typeData: PropTypes.object.isRequired,
  onPriceOfferSubmitSuccess: PropTypes.func.isRequired,
  onPriceOfferDecisionSuccess: PropTypes.func.isRequired,
}

export default BottomHeaderRowPriceOffer
